/**
 * Vite/React bootstrap: mounts `App` into `#root` inside `StrictMode`.
 *
 * Where: referenced from `index.html` as the UI entry bundle.
 * Uses: `./App` only.
 * Behavior: `StrictMode` double-invokes effects in development only.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
